export function getActivityTypes() {
    return axios({
        url: `api/activity-types`,
        method: 'get',
    });
}
